import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';
import { AnalysisResult } from '../types';

interface ValidationChartProps {
  result: AnalysisResult;
}

export const ValidationChart: React.FC<ValidationChartProps> = ({ result }) => {
  const { validation } = result;
  
  if (!validation) return null;

  const data = [
    ...validation.powerAccuracy.map((accuracy, index) => ({
      trial: `Trial ${index + 1}`,
      type: 'Power',
      accuracy: accuracy,
      error: accuracy
    })),
    ...validation.timeAccuracy.map((accuracy, index) => ({
      trial: `Trial ${index + 1}`,
      type: 'Time',
      accuracy: accuracy,
      error: accuracy
    }))
  ];

  return (
    <div className="bg-theme-surface-1 border border-theme-border rounded-2xl p-6 shadow-card">
      <h3 className="text-2xl font-semibold tracking-tight text-theme-text mb-6">Measurement Validation</h3>
      
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
            <XAxis 
              dataKey="trial" 
              stroke="#9CA3AF"
              label={{ value: 'Trial', position: 'insideBottom', offset: -10, style: { textAnchor: 'middle', fill: '#9CA3AF' } }}
            />
            <YAxis 
              stroke="#9CA3AF"
              label={{ value: 'Error (%)', angle: -90, position: 'insideLeft', style: { textAnchor: 'middle', fill: '#9CA3AF' } }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#1F2937', 
                border: '1px solid #374151', 
                borderRadius: '8px',
                color: '#F9FAFB'
              }}
              formatter={(value: number) => [`${value.toFixed(1)}%`, 'Measurement Error']}
            />
            <Bar 
              dataKey="error" 
              fill="#60A5FA"
              stroke="#60A5FA"
              strokeWidth={1}
            />
            <ReferenceLine 
              y={10} 
              stroke="#F59E0B" 
              strokeDasharray="5 5"
              label={{ value: "10% Threshold", position: "right", style: { fill: '#F59E0B' } }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
      
      <div className="mt-4 text-sm text-theme-muted">
        <p>Measurement Errors (&gt;10%): <span className="text-theme-accent font-semibold">{validation.measurementErrors}</span></p>
        <p>Power Accuracy: <span className="text-green-400">Good</span> (&lt;10%), <span className="text-red-400">Poor</span> (&gt;10%)</p>
      </div>
    </div>
  );
};